// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderAndFilter_container__12_0T","item":"OrderAndFilter_item__1qWH2","tags":"OrderAndFilter_tags__1zG7B"};